import {hasValue} from "./utils";

/**
 * Builds sort functions of the type used to sort arrays (a:Any,b:Any):Number
 * These functions can be used to build sort functions to use in SMCTable
 */

// Sort by string, case sensitive
export function buildStringSort(id) {
    return (a, b) => {
        const strA = a[id];
        const strB = b[id];

        if (strA === strB) {
            return 0;
        }
        if (!strA) {
            return 1;
        }
        if (!strB) {
            return -1;
        }
        return strA.localeCompare(strB);
    };
}

// Sort by string, case insensitive
export function buildStringSortCaseInsensitive(id) {
    return (a, b) => {
        const strA = a[id];
        const strB = b[id];

        if (strA === strB) {
            return 0;
        }
        if (!strA) {
            return 1;
        }
        if (!strB) {
            return -1;
        }
        return strA.localeCompare(strB, 'en', { 'sensitivity': 'base' });
    };
}

// Sort by if value exists (is not null or undefined)
// value exists > value not exists
export function buildExistsSort(id) {
    return (a, b) => {
        const valA = a[id];
        const valB = b[id];
        if (valA === valB) {
            return 0;
        }
        if (valA === null || typeof valA === 'undefined') {
            return 1;
        }
        return -1;
    }
}

// Sort by boolean
// true > false
export function buildBooleanSort(id) {
    return (a, b) => {
        const valA = a[id];
        const valB = b[id];
        if (valA === valB) {
            return 0;
        }
        if (valA) {
            return 1;
        }
        return -1;
    }
}

// Sort by number
// If number doesn't exist, it is always smaller then an existing number
export function buildNumberSort(id) {
    return (a, b) => {
        const numA = a[id];
        const numB = b[id];
        if (numA === numB) {
            return 0;
        }
        if (!numA) {
            return 1;
        }
        if (!numB) {
            return -1;
        }

        return numA-numB;
    }
}

// Sort by weight
// valueToWeight object should match each value to a number weight, 0 being last and the highest number being first
export function buildWeighedSort(id, valueToWeight) {
    return (a, b) => {
        const valAWeight = valueToWeight[a[id]];
        const valBWeight = valueToWeight[b[id]];
        if (valAWeight === valBWeight) {
            return 0;
        }
        if (!hasValue(valAWeight)) {
            return 1;
        }
        if (!hasValue(valBWeight)) {
            return -1;
        }

        return valAWeight - valBWeight;
    }

}